function setupDetailBackButton () {
  const closeButton = document.querySelector('.detail-close-button')
  if (!closeButton) return

  closeButton.addEventListener('click', (event) => {
    event.preventDefault()

    const fallbackHref = closeButton.getAttribute('data-fallback-href')

    if (fallbackHref && document.referrer) {
      const referrerPath = new URL(document.referrer).pathname
      const fallbackPath = new URL(fallbackHref, document.location.origin).pathname

      if (referrerPath === fallbackPath) {
        history.back()
        return
      }
    }

    location.replace(fallbackHref)
  })
}

window.addEventListener('DOMContentLoaded', setupDetailBackButton)
